import {useState, useRef, useEffect} from "react";
import "styles/panel/update.panel.css";
import SideDrawer from "components/drawers/side.drawer";
import {CaretLeftIcon, XIcon} from "@phosphor-icons/react";
import {useData} from "context/data.context";
import UpdateTableCard from "components/panels/update/cards/update.table.card";
import { CaretCircleLeftIcon } from "@phosphor-icons/react/dist/ssr";

const UpdatePanel = (props) => {
  const { networthCurrent, updateAsset, updateLiability } = useData();
  const [closing, setClosing] = useState(false);
  const [changed, setChanged] = useState(false);
  const [activeTab, setActiveTab] = useState("assets");
  const carouselRef = useRef(null);

  const allAssets = networthCurrent.assets.classes.flatMap(c => c.items);
  const allLiabilities = networthCurrent.liabilities.classes.flatMap(c => c.items);
  const [assetValues, setAssetValues] = useState(Object.fromEntries(allAssets.map((a) => [a.id, a.valuation])));
  const [liabilityValues, setLiabilityValues] = useState(Object.fromEntries(allLiabilities.map((l) => [l.id, l.valuation])));

  // Sync tabs with scroll position
  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    const handleScroll = () => {
      const scrollLeft = carousel.scrollLeft;
      const pageWidth = carousel.offsetWidth;
      const currentPage = Math.round(scrollLeft / pageWidth);
      setActiveTab(currentPage === 0 ? "assets" : "liabilities");
    };

    carousel.addEventListener("scroll", handleScroll);
    carousel.addEventListener("scrollend", handleScroll);

    return () => {
      carousel.removeEventListener("scroll", handleScroll);
      carousel.removeEventListener("scrollend", handleScroll);
    };
  }, []);

  const handleClose = () => setClosing(true);

  const handleAssetChange = (id, value) => {
    setAssetValues((prev) => ({...prev, [id]: value}));
    const original = allAssets.find((a) => a.id === id)?.valuation;
    if (Number(value) !== original) setChanged(true);
  };

  const handleLiabilityChange = (id, value) => {
    setLiabilityValues((prev) => ({...prev, [id]: value}));
    const original = allLiabilities.find((l) => l.id === id);
    if (Number(value) !== original?.valuation) setChanged(true);
  };

  const handleSave = () => {
    const today = new Date().toISOString().split('T')[0];

    props.onCancel();

    Promise.all([
      ...allAssets
        .filter((a) => Number(assetValues[a.id]) !== a.valuation)
        .map((a) => {
          const newValuation = Number(assetValues[a.id]);
          const history = [...(a.history || [])].filter((r) => r.date !== today);
          history.unshift({ date: today, valuation: newValuation });
          return updateAsset({...a, valuation: newValuation, history}, a.id);
        }),
      ...allLiabilities
        .filter((l) => Number(liabilityValues[l.id]) !== l.valuation)
        .map((l) => {
          const newValuation = Number(liabilityValues[l.id]);
          const history = [...(l.history || [])].filter((r) => r.date !== today);
          history.unshift({ date: today, valuation: newValuation });
          return updateLiability(l.id, {...l, valuation: newValuation, history});
        }),
    ]);
  };



  return (
    <>
   
      <div className="Update light" closing={closing}>
        <div className=" light flex col large-gap">
          <div className="flex row space">
   
            <p className="large">Update Portfolio</p>
   

                 <div className="icon large" onClick={props.onCancel}>
              <XIcon  />
            </div>
          </div>


          <div className="tab-group large">
            <input type="radio" name="update-tab" id="tab-assets" checked={activeTab === "assets"} onChange={() => setActiveTab("assets")} />
            <label htmlFor="tab-assets" onClick={() => carouselRef.current?.scrollTo({ left: 0, behavior: "smooth" })}>
              Assets
            </label>
            <input type="radio" name="update-tab" id="tab-liabilities" checked={activeTab === "liabilities"} onChange={() => setActiveTab("liabilities")} />
            <label htmlFor="tab-liabilities" onClick={() => carouselRef.current?.scrollTo({ left: carouselRef.current.offsetWidth, behavior: "smooth" })}>
              Liabilities
            </label>
          </div>

          <div className="carousel" ref={carouselRef}>
            <div className="page" id="assets">
              <div className="card">
                <UpdateTableCard classification="Properties" items={networthCurrent.assets.classes.find(c => c.name ==='Property')?.items || []} onValueChange={handleAssetChange} />
                <UpdateTableCard classification="Pensions" items={networthCurrent.assets.classes.find(c => c.name ==='Pension')?.items || []} onValueChange={handleAssetChange} />
                <UpdateTableCard classification="Investments" items={networthCurrent.assets.classes.find(c => c.name ==='Investment')?.items || []} onValueChange={handleAssetChange} />
                <UpdateTableCard classification="Savings" items={networthCurrent.assets.classes.find(c => c.name ==='Savings')?.items || []} onValueChange={handleAssetChange} />
                <UpdateTableCard classification="Other" items={networthCurrent.assets.classes.find(c => c.name ==='Other')?.items || []} onValueChange={handleAssetChange} />
              </div>
            </div>
            <div className="page" id="liabilities">
              <div className="card">
                <UpdateTableCard classification="Mortgages" items={networthCurrent.liabilities.classes.find(c => c.name ==='Mortgage')?.items || []} onValueChange={handleLiabilityChange} />
                <UpdateTableCard classification="Long Term Debts" items={networthCurrent.liabilities.classes.find(c => c.name ==='Long Term Debt')?.items || []} onValueChange={handleLiabilityChange} />
                <UpdateTableCard classification="Short Term Debts" items={networthCurrent.liabilities.classes.find(c => c.name ==='Short Term Debt')?.items || []} onValueChange={handleLiabilityChange} />
              </div>
            </div>
          </div>

          <div className="flex col regular-gap">
            <button className="Save button large" disabled={!changed} onClick={handleSave}>
              Save all
            </button>
            <button className="cancel button large" onClick={props.onCancel}>
              Cancel
            </button>
          </div>
        </div>
      </div>

    </>
  );
};

export default UpdatePanel;
